export const relations = [
  {
    name: 'elementType',
    relatedKey: 'id',
    relatedParentKey: 'elementTypeId',
  },
];

export const relatedParentKey = 'formTemplateId';
